import { io, Socket } from 'socket.io-client'

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000/api'
const SOCKET_URL = API_BASE_URL.replace('/api', '')

class SocketService {
  private socket: Socket | null = null

  /**
   * Connects to the Socket.IO server with auth token
   * @param token - JWT token
   */
  connect(token: string): void {
    if (this.socket?.connected) return

    this.socket = io(SOCKET_URL, {
      transports: ['websocket'],
      auth: { token },
      reconnection: true,
      reconnectionDelay: 2000,
      reconnectionAttempts: 10,
    })

    this.socket.on('connect', () => {
      console.log('Socket connected')
    })

    this.socket.on('connect_error', (error) => {
      console.error('Socket connection error:', error.message)
    })
  }

  /**
   * Disconnects from the server
   */
  disconnect(): void {
    if (this.socket) {
      this.socket.disconnect()
      this.socket = null
    }
  }

  /**
   * Registers an event listener
   * @param event - Event name
   * @param handler - Event handler
   */
  on(event: string, handler: (...args: any[]) => void): void {
    this.socket?.on(event, handler)
  }

  /**
   * Removes an event listener
   * @param event - Event name
   * @param handler - Event handler
   */
  off(event: string, handler: (...args: any[]) => void): void {
    this.socket?.off(event, handler)
  }

  /**
   * Returns whether socket is connected
   */
  get connected(): boolean {
    return this.socket?.connected ?? false
  }
}

export const socketService = new SocketService()
